import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="text-lg font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>Privacy Policy</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-10 prose prose-sm">
        <h1 style={{ fontFamily: 'Outfit, sans-serif' }}>Privacy Policy</h1>
        <p><strong>Last updated:</strong> March 12, 2026</p>
        <p>Gloverse ("we", "our", "us") operates the website gloverse.in and the Gloverse mobile application (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service.</p>

        <h2>Information We Collect</h2>
        <ul>
          <li><strong>Account Information:</strong> When you sign up, we collect your name, email address, phone number, and profile picture through Google Sign-In or Phone OTP verification.</li>
          <li><strong>Content You Create:</strong> Posts, checklists, Looks, comments, and messages you create on Gloverse.</li>
          <li><strong>Usage Data:</strong> We collect information about how you interact with the Service, including product clicks, page views, and feature usage.</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <ul>
          <li>To provide and maintain the Service</li>
          <li>To personalize your experience and show relevant content</li>
          <li>To track product click analytics for creators</li>
          <li>To communicate with you about updates and features</li>
          <li>To detect and prevent fraud or abuse</li>
        </ul>

        <h2>Data Sharing</h2>
        <p>We do not sell your personal data. We may share data with:</p>
        <ul>
          <li>Service providers who help us operate the platform (hosting, analytics)</li>
          <li>Product brands through anonymized, aggregated click data</li>
          <li>Law enforcement when required by law</li>
        </ul>

        <h2>Data Security</h2>
        <p>We use industry-standard security measures to protect your data, including encrypted connections (HTTPS), secure authentication, and access controls.</p>

        <h2>Your Rights</h2>
        <p>You can request to access, update, or delete your personal data at any time by contacting us at <strong>info@gloverse.in</strong>.</p>

        <h2>Cookies</h2>
        <p>We use cookies and similar technologies to maintain your session and improve the Service experience.</p>

        <h2>Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>

        <h2>Contact Us</h2>
        <p>If you have questions about this Privacy Policy, contact us at <strong>info@gloverse.in</strong>.</p>
      </div>
    </div>
  );
}
